import React from "react";

const SkeletonMyOrder = () => {
  return (
    <>
      <div className="flex flex-col gap-4 w-full bg-gray-100 rounded-2xl m-3 p-3">
        <div className="flex flex-col justify-center gap-3">
          <div className="flex flex-col items-center gap-2">
            <div className="h-12 w-12 bg-gray-300 animate-pulse rounded-full" />
            <div className="h-4 w-40 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-36 bg-gray-300 animate-pulse rounded" />
          </div>
        </div>

        <div className="flex justify-center gap-10">
          <div className="flex flex-col items-center">
            <div className="h-16 w-16 bg-gray-300 animate-pulse rounded-full" />
            <div className="h-3 w-16 bg-gray-300 animate-pulse rounded mt-2" />
          </div>
          <div className="flex flex-col items-center">
            <div className="h-16 w-16 bg-gray-300 animate-pulse rounded-full" />
            <div className="h-3 w-20 bg-gray-300 animate-pulse rounded mt-2" />
          </div>
        </div>

        <hr className="my-3" />

        <div className="flex flex-col gap-2">
          <div className="h-4 w-28 bg-gray-300 animate-pulse rounded" />
          <div className="h-4 w-40 bg-gray-300 animate-pulse rounded" />
        </div>
      </div>

      <div className="w-full bg-gray-100 shadow-lg rounded-2xl p-3">
        <div className="flex flex-col gap-3">
          {[...Array(2)].map((_, index) => (
            <div key={index} className="flex items-center gap-3">
              <div className="h-14 w-14 bg-gray-300 animate-pulse rounded" />
              <div className="flex flex-col gap-2">
                <div className="h-4 w-36 bg-gray-300 animate-pulse rounded" />
                <div className="h-3 w-24 bg-gray-300 animate-pulse rounded" />
              </div>
            </div>
          ))}

          <hr className="my-3" />

          <div className="flex justify-between text-sm">
            <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-10 bg-gray-300 animate-pulse rounded" />
          </div>

          <hr className="my-3" />

          <div className="flex justify-between text-sm">
            <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-10 bg-gray-300 animate-pulse rounded" />
          </div>

          <hr className="my-3" />

          <div className="flex flex-col justify-center py-4">
            <div className="h-4 w-16 bg-gray-300 animate-pulse rounded mx-auto mb-2" />
            <div className="flex flex-col justify-center gap-3 text-lg font-semibold">
              <div className="flex justify-center gap-1">
                <div className="h-5 w-24 bg-gray-300 animate-pulse rounded" />
                <div className="h-5 w-24 bg-gray-300 animate-pulse rounded" />
              </div>
            </div>
          </div>

          <hr className="my-3" />

          <div className="flex flex-col gap-2 text-sm pt-4">
            <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-16 bg-gray-300 animate-pulse rounded" />

            <hr className="my-3" />

            <div className="h-4 w-32 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />

            <hr className="my-3" />

            <div className="h-4 w-28 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-20 bg-gray-300 animate-pulse rounded" />

            <hr className="my-3" />

            <div className="h-4 w-32 bg-gray-300 animate-pulse rounded" />
            <div className="h-4 w-24 bg-gray-300 animate-pulse rounded" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SkeletonMyOrder;
